<template>
	<sf-modal-layout size="s" :title="title" :show="show" :closeModal="close">
		<h4 class="title-box" v-html="getMessage_('SWCC000687')">
			<!-- {{ `${_getMessage('SWCC000687')}` }}
			'소스' 그룹의 메뉴/권한 리스트가 '타겟' 그룹으로 복사되며,<br />
			모든 권한은 '미사용'으로 기본 설정됩니다. -->
		</h4>
		<el-form class="sfaas-form" ref="form" :model="form" label-width="auto">
			<div class="sfaas-form-group">
				<el-form-item :label="getMessage_('SWCC000865')">
					<el-select v-model="form.permGrpCd" placeholder="Select">
						<el-option v-for="(group, index) in groups" :label="group.userGrpName" :value="group.permGrpCd" :key="index"></el-option>
					</el-select>
				</el-form-item>
			</div>

			<div class="sfaas-form-group">
				<el-form-item :label="getMessage_('SWCC000866')">
					<el-select v-model="form.userGrpCd" placeholder="Select">
						<el-option v-for="(group, index) in groups" :label="group.userGrpName" :value="group.permGrpCd" :key="index"></el-option>
					</el-select>
				</el-form-item>
			</div>
		</el-form>
		<template v-slot:footer>
			<sf-button line :onClick="close">{{ getMessage_('SWCC000343') }}</sf-button>
			<sf-button :onClick="saveClick">{{ getMessage_('SWCC000423') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';

export default {
	data() {
		return {
			show: false,
			form: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('SWCC000435'); // 사용자 그룹 권한 관리 복사
		}
	},
	methods: {
		...serviceMethods,
		open() {
			this.show = true;
		},
		close() {
			this.form.permGrpCd = this.form.userGrpCd = null;
			this.$emit('Refresh');
			this.show = false;
		},
		save() {
			this.$sf_toggleLoading(true);
			let sendData = {
				plantCd: this.searchParams.plantCd,
				permGrpCd: this.form.permGrpCd,
				userGrpCd: this.form.userGrpCd
				// regId: this.user.userId,
			};

			Object.keys(sendData).forEach(val => {
				sendData[val] = sendData[val].toString().trim();
			});

			this.postGroupCopy_(sendData)
				.then(response => {
					if (response.messageCd != undefined && response.messageCd != null) {
						// this.$sf_toast({ message: response.messageCd });
						this.$sf_toast({ type: 'ok', message: this.getMessage_(response.messageCd) });
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.close();
					this.$sf_toggleLoading(false);
				});
		},
		saveClick() {
			if (this.form.permGrpCd == undefined || this.form.userGrpCd == undefined) {
				// title 선택한 정보가 없습니다..
				// message 소스/타겟을 선택해주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000441') });
				return;
			}

			if (this.form.permGrpCd == this.form.userGrpCd) {
				// title 복사할 그룹이 없습니다.
				// message 소스/타겟을 다르게 선택해주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000442'), message: this.getMessage_('SWCC000443') });
				return;
			}

			{
				let showMsg1 = this.getMessage_('SWCC000444');
				let showMsg2 = this.getMessage_('SWCC000445');
				this.$sf_showMessage({
					icon: 'confirm',
					type: 'confirm',
					message: `${showMsg1}<br>${showMsg2}`, // 테스트 그룹 설정이 초기화 됩니다.<br>계속하시겠습니까?
					buttons: [{ title: 'Ok', clickFn: this.save }]
				});
			}
		}
	}
};
</script>

<style scoped>
.title-box {
	display: block;
	line-height: 150%;
	text-align: center;
}
</style>
